import { render, staticRenderFns } from "./CardTabsView.vue?vue&type=template&id=a92a66a4&scoped=true&"
import script from "./CardTabsView.vue?vue&type=script&lang=js&"
export * from "./CardTabsView.vue?vue&type=script&lang=js&"
import style0 from "./CardTabsView.vue?vue&type=style&index=0&id=a92a66a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92a66a4",
  null
  
)

export default component.exports